/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1NotificationMobileAppNotificationidMutationRequest,
  PutApiV1NotificationMobileAppNotificationidMutationResponse,
  PutApiV1NotificationMobileAppNotificationidPathParams,
  PutApiV1NotificationMobileAppNotificationid400,
  PutApiV1NotificationMobileAppNotificationid401,
  PutApiV1NotificationMobileAppNotificationid500,
} from "../../types/notificationMobileAppController/PutApiV1NotificationMobileAppNotificationid.ts";

function getPutApiV1NotificationMobileAppNotificationidUrl(
  notificationId: PutApiV1NotificationMobileAppNotificationidPathParams["notificationId"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/notification/mobile-app/${notificationId}` as const,
  };
  return res;
}

/**
 * @description Permite editar todos os campos de uma notificação (título, mensagem, turmas, status de matrícula, agendamento, URL externa). Aceita somente notificações com status Rascunho (6) ou Agendado (2). Notificações em processamento, concluídas ou canceladas não podem ser editadas. **(Requer Authorization para autenticação)**
 * @summary Edita uma notificação mobile (Requer Authorization para autenticação)
 * {@link /api/v1/notification/mobile-app/:notificationId}
 */
export async function putApiV1NotificationMobileAppNotificationid(
  notificationId: PutApiV1NotificationMobileAppNotificationidPathParams["notificationId"],
  data?: PutApiV1NotificationMobileAppNotificationidMutationRequest,
  config: Partial<
    RequestConfig<PutApiV1NotificationMobileAppNotificationidMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1NotificationMobileAppNotificationidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1NotificationMobileAppNotificationid400
      | PutApiV1NotificationMobileAppNotificationid401
      | PutApiV1NotificationMobileAppNotificationid500
    >,
    PutApiV1NotificationMobileAppNotificationidMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1NotificationMobileAppNotificationidUrl(
      notificationId,
    ).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
